// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1CeiW","filesListContainer":"PosDisputesFiles_filesListContainer__gSjmY","filesButton":"PosDisputesFiles_filesButton__3wX5D"};